import { Component, OnInit, Input, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { PictographConfiguration, PictographYearConfiguration } from "./pictograph.configuration";
import { TitleLineConfigurations, TitleConfigurations } from "../title/title.configurations";
import { KlaHttpService } from "../services/kla.http.service";
import { CommonModule } from '@angular/common';
import { RoundButtonComponent } from '../round-button/round-button.component';
import { TitleComponent } from '../title/title.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-pictograph',
  templateUrl: './pictograph.component.html',
  styleUrls: ['./pictograph.component.scss'],
  standalone: true,
  imports: [ CommonModule, RoundButtonComponent, TitleComponent, DynamicContentComponent ]
})
export class PictographComponent implements OnInit {

  @Input()
  public pictographConfig: PictographConfiguration

  @Input()
  public config: {
    chartId: string,
    image: string,
    title: TitleConfigurations,
    chartAltText?: string
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  @ViewChild('pictographContent', { read: ElementRef }) containerEl: ElementRef;
  @ViewChild('col1', { read: ElementRef }) col1El: ElementRef;
  @ViewChild('col2', { read: ElementRef }) col2El: ElementRef;
  @ViewChildren(RoundButtonComponent, { read: ElementRef }) roundButtons: QueryList<ElementRef>;

  public maxNumber = [];

  public activePictograph: PictographYearConfiguration;

  public showSecondPictograph = false;

  public selectedButton = 0;

  constructor(private httpService: KlaHttpService) { }

  ngOnInit() {
    this.httpService.getChartData("kla-pictograph", this.config.chartId).subscribe(
      (data) => {
        this.pictographConfig = {
          data: data ? data.items : undefined
        }

        if (!this.pictographConfig.data) {
          console.error("Please provide pictograph chart configurations");
        } else {
          this.initPictograph();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }
  initPictograph() {

    this.maxNumber = Array.from(Array(100).keys())
    this.activePictograph = this.pictographConfig.data[0];
    this.activePictograph.firstGraph.percentage = Math.round(this.activePictograph.firstGraph.percentage);

    this.checkSecondGraph();
  }

  changeActivePictograph(index: number) {
    this.selectedButton = index;
    this.showSecondPictograph = false;
    this.activePictograph = this.pictographConfig.data[index];
    this.checkSecondGraph();
  }

  onContainerKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && event.target === this.containerEl?.nativeElement) {
      event.preventDefault();
      this.col1El?.nativeElement?.focus();
    }
  }

  onDataColKeydown(event: KeyboardEvent, colIndex: number) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.containerEl?.nativeElement?.focus();
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      if (colIndex === 0 && this.showSecondPictograph) {
        this.col2El?.nativeElement?.focus();
      } else {
        this.roundButtons.first?.nativeElement.querySelector('button')?.focus();
      }
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      if (colIndex === 1) {
        this.col1El?.nativeElement?.focus();
      }
    }
  }

  onYearKeydown(event: KeyboardEvent, index: number) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.containerEl?.nativeElement?.focus();
      return;
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      this.changeActivePictograph(index);
      this.col1El?.nativeElement?.focus();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      const target = this.showSecondPictograph ? this.col2El : this.col1El;
      target?.nativeElement?.focus();
      return;
    }

    const total = this.pictographConfig.data.length;
    let newIndex = index;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      newIndex = (index + 1) % total;
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      newIndex = (index - 1 + total) % total;
    } else {
      return;
    }

    this.roundButtons.get(newIndex)?.nativeElement.querySelector('button')?.focus();
  }

  checkSecondGraph() {
    if (this.activePictograph.secondGraph) {
      this.showSecondPictograph = true;
      this.activePictograph.secondGraph.percentage = Math.round(this.activePictograph.secondGraph.percentage);
    }
  }

}
